import { gql, useQuery } from '@apollo/client';
import _flatten from 'lodash/flatten';
import _orderBy from 'lodash/orderBy';

const TICKETS_BY_MEMBER_EVENT_ID = gql`
  query ticketsByMemberEventId ($id: Int!) {
    allTicketTypes(filter: {
      memberEventId: {
        equalTo: $id
      },
      deletedAt: {
        isNull: true,
      }
    }) {
      nodes {
        id
        name
        ticketsByTicketTypeId(
          filter: {
            deletedAt: {
              isNull: true
            }
          },
          orderBy: ID_DESC,
        ) {
          nodes {
            id
            name
            email
            creditRedemptionByCreditRedemptionId {
              id
              userByUserId {
                id
                givenNames
                familyName
                email
              }
            }
            purchaseByPurchaseId {
              id
              givenNames
              familyName
              email
            }
            ticketTypeByTicketTypeId {
              id
              name
            }
            claimedAt
            createdAt
          }
        }
      }
    }
  }
`;

const useMemberEventTickets = (memberEventId, query) => {
  const {
    loading,
    error,
    data: rawData,
    refetch,
  } = useQuery(query || TICKETS_BY_MEMBER_EVENT_ID, {
    variables: { id: +memberEventId },
    skip: !memberEventId,
    fetchPolicy: 'network-only',
  });

  let data;
  if (!loading && rawData) {
    // Unnest tickets by type and add clean up purchaser data
    const ticketsByType = rawData.allTicketTypes.nodes.map(({ name, ticketsByTicketTypeId }) => (
      ticketsByTicketTypeId.nodes.map((ticket) => {
        const { creditRedemptionByCreditRedemptionId, purchaseByPurchaseId } = ticket;
        let purchaser;
        if (creditRedemptionByCreditRedemptionId) {
          purchaser = creditRedemptionByCreditRedemptionId.userByUserId;
        } else if (purchaseByPurchaseId) {
          const {
            email,
            givenNames,
            familyName,
          } = purchaseByPurchaseId;
          purchaser = {
            email,
            givenNames,
            familyName,
            isGuest: true,
          };
        }
        return ({
          ...ticket,
          purchaser,
          ticketType: name,
        });
      })
    ));
    const tickets = _flatten(ticketsByType);
    data = _orderBy(tickets, ['id'], 'desc');
  }
  return {
    loading,
    data,
    error,
    refetch,
  };
};

export default useMemberEventTickets;
